import { render, staticRenderFns } from "./distributor.vue?vue&type=template&id=39bf1cc5"
var script = {}
import style0 from "./distributor.vue?vue&type=style&index=0&id=39bf1cc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports